module.exports = __webpack_public_path__ + "img/teaser-title.43944f0a.webp";